/**
 * @generated SignedSource<<cd59610f8da958d48425a6e89b8df13c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetTaskSingleGroupingMode = "SECTION" | "TEAM";
export type WidgetTaskSingleUpdateInput = {
  setGrouping?: WidgetTaskSingleGroupingMode | null;
  setSectionIds?: ReadonlyArray<string> | null;
  setTaskId?: string | null;
  setTeamIds?: ReadonlyArray<string> | null;
};
export type WSTaskSingleMutation$variables = {
  id: string;
  storecastId: string;
  update: WidgetTaskSingleUpdateInput;
};
export type WSTaskSingleMutation$data = {
  readonly dashboard: {
    readonly updateWidgetTaskSingle: {
      readonly id: string;
    };
  };
};
export type WSTaskSingleMutation = {
  response: WSTaskSingleMutation$data;
  variables: WSTaskSingleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "update"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "update",
            "variableName": "update"
          }
        ],
        "concreteType": "WidgetTaskSingle",
        "kind": "LinkedField",
        "name": "updateWidgetTaskSingle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WSTaskSingleMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "WSTaskSingleMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d3fc290af1010ed6afe585c151d7ffc6",
    "id": null,
    "metadata": {},
    "name": "WSTaskSingleMutation",
    "operationKind": "mutation",
    "text": "mutation WSTaskSingleMutation(\n  $storecastId: ID!\n  $id: ID!\n  $update: WidgetTaskSingleUpdateInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    updateWidgetTaskSingle(id: $id, update: $update) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc42ae1a9c728a1c864d586e4d00c159";

export default node;
